<script setup>
const model = defineModel({ type: String, required: true })
</script>

<template>
  <q-card flat class="my-card q-mb-md grid-detail-tabs">
    <div class="grid-detail-tabs__header">
      <q-tabs
        v-model="model"
        align="left"
        class="text-primary"
        active-color="primary"
        indicator-color="primary"
        narrow-indicator
        dense
      >
        <slot name="tabs" />
      </q-tabs>
    </div>
    <q-tab-panels v-model="model" animated class="grid-detail-tabs__panels">
      <slot name="panels" />
    </q-tab-panels>
  </q-card>
</template>

<style scoped>
.grid-detail-tabs__header {
  border: 1px solid var(--q-separator-color, #e0e0e0);
  border-radius: .25rem .25rem 0 0;
}
.grid-detail-tabs__panels {
  border: 1px solid var(--q-separator-color, #e0e0e0);
  border-top: none;
  border-radius: 0 0 .25rem .25rem;
}
</style>
